import type { ReactNode } from 'react';
import Tooltip from '@mui/material/Tooltip';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface Props {
  text: string;
  children: ReactNode;
}

export default function InfoTip({ text, children }: Props) {
  return (
    <span className="ds-infotip-wrap">
      {children}
      <Tooltip
        title={text}
        placement="top"
        arrow
        componentsProps={{
          tooltip: {
            sx: {
              bgcolor: 'rgba(97, 97, 97, 0.92)',
              color: '#fff',
              border: 'none',
              fontSize: '1.2rem',
              lineHeight: '1.6rem',
              maxWidth: 220,
              px: 1.2,
              py: 0.6,
            },
          },
          arrow: {
            sx: {
              color: 'rgba(97, 97, 97, 0.92)',
              '&::before': {
                backgroundColor: 'rgba(97, 97, 97, 0.92)',
                border: 'none',
              },
            },
          },
        }}
      >
        <InfoOutlinedIcon className="ds-infotip-icon" />
      </Tooltip>
    </span>
  );
}
